import ControlledForm from "Components/ControlledForm";
import ControlledTable from "Components/ControlledTable";
import { FormDataType } from "DataTypes/Form";
import { columnType } from "DataTypes/Table";
export const TableCol: columnType[] = [
  ControlledTable.ColumnData.InterventionCol(),
  ControlledTable.ColumnData.GoalCol(),
];

export const Arr: FormDataType[] = [
  ControlledForm.FormData.AddNotes({ multiline: 6 }),
  ControlledForm.FormData.Callfreq(),
  ControlledForm.FormData.CompletionDate(),
];

export const Arr1: FormDataType[] = [
  {
    id: "message",
    label: "Message",
    placeholder: "Add Message",
    boxType: "input-box",
    type: "text",
    boxSize: 3,
    validatetype: "notes",
    readOnly: true,
  }
];
